
const noAvatar = 'account-circle.svg'


export default {
  methods: {
    getImage(image, size = 'medium') {

      if (image == null) {
        return `${process.env.BASE_URL}${noAvatar}`
      }

      const baseUrl = process.env.VUE_APP_IMAGES_BASE_URL

      if (size && image.generated_conversions && image.generated_conversions[size]) {

        const fileNameWithoutExt = image.file_name.substring(0, image.file_name.lastIndexOf('.'))

        return `${baseUrl}${image.id}/conversions/${fileNameWithoutExt}-${size}.jpg`
      }

      return `${baseUrl}${image.id}/${image.file_name}`
    }
  }
}